import { debounce } from '../helpers/helpers';

/* eslint-disable no-alert */
/* eslint-disable func-names */
/* eslint-disable no-undef */
const cookieBar = () => {
  (function ($) {
    const $cookie = $('.c-cookie');
    const $acceptCookie = $('.js-cookie-accept');
    const $cookieClose = 'c-cookie--close';
    // const $headerHeight = $('.c-header').height();
    const $cookieHeight = $('.c-cookie').outerHeight();
    const $main = $('#main');
    const $header = $('.c-header');

    // console.log($headerHeight);
    // console.log($cookieHeight);

    $main.css('margin-top', $cookieHeight);
    $header.css('margin-top', $cookieHeight);

    // Set a Cookie
    const setCookie = (cname, cvalue, exdays) => {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      const expires = `expires=${d.toGMTString()}`;
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    };

    // Get a Cookie
    const getCookie = (cname) => {
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    };

    // Check a Cookie
    const checkCookie = () => {
      let cookie = getCookie('cookie');

      if (cookie !== '') {
        $main.css('margin-top', 0);
        $header.css('margin-top', 0);
        $cookie.addClass($cookieClose);
        $cookie.hide();
        // console.log(`Welcome again ${cookie}`);
      } else {
        $cookie.show();

        $acceptCookie.on('click', () => {
          cookie = 'cookie accepted';
          $cookie.addClass($cookieClose);
          $main.css('margin-top', 0);
          $header.css('margin-top', 0);

          if (cookie !== '' && cookie != null) {
            setCookie('cookie', cookie, 365);
          }
        });
      }
    };

    $(window).on('resize', debounce(150, () => {
      if (!$cookie.hasClass($cookieClose)) {
        const $cookieHeightNew = $('.c-cookie').outerHeight();
        $main.css('margin-top', $cookieHeightNew);
        $header.css('margin-top', $cookieHeightNew);
      }
    }));

    checkCookie();
  }(jQuery));
};

export default cookieBar;
